export default __webpack_public_path__ + "static/media/background.947710ce.jpg";